<!-- dashboard-popup.component.html -->

<div class="col-md-12">

  <!-- Search Box -->
  <div class="head">
    <div id="funBtn">
      <h2>Function Name: {{ data.functTypeKey }}</h2>

      <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()" style="border: 1px solid gray;"></button>
    </div>
  
    <div class="searchField">
      <div class="input-group mb-3 search">
        <input type="text" class="form-control" placeholder="Search" aria-label="Search" #filterInput (keyup)="applyFilter(filterInput.value)">
        
      </div>
    </div>
  </div>

  <!-- TABLE -->
  <div class="table-container">
    <mat-table [dataSource]="paginatedData" matSort>
      <!-- Column: Employee ID -->
      <ng-container matColumnDef="employeeId"> 
        <mat-header-cell *matHeaderCellDef mat-sort-header>EmpCode</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.designation !== 'Visitors'">
            {{ element.employeeId }}
          </ng-container>
        </mat-cell>
      </ng-container>
      
  
      <!-- Column: Designation -->
      <ng-container matColumnDef="designation">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Function</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.designation }}</mat-cell>
      </ng-container>
  
      <!-- Column: Full Name -->
      <ng-container matColumnDef="fullName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.fullName || element.visitorName }}</mat-cell>
      </ng-container>
  
      <!-- Column: Mobile Number -->
      <ng-container matColumnDef="mobileNumber"> 
        <mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</mat-header-cell>
        <mat-cell *matCellDef="let element"> 
          <ng-container *ngIf="element.designation === 'White Collar'; else maskedNumber">
            <ng-container *ngIf="element.mobileNumber; else maskedNumber">
              <a [href]="'tel:' + element.mobileNumber" 
                 [title]="'Call ' + element.mobileNumber" 
                 [attr.aria-label]="'Call ' + element.mobileNumber">
                {{ element.mobileNumber }}
              </a>
            </ng-container>
          </ng-container>
          
          <ng-template #maskedNumber>
            <a href="tel:98#######" title="Call 98#######" aria-label="Call 98#######">
              98###### 
            </a>
          </ng-template>
        </mat-cell>
      </ng-container>
      
      <!-- Table Header & Row Definitions -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>

  <!-- Pagination -->
  <!-- Pagination -->
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-end">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="previousPage()"><span aria-hidden="true">&laquo;</span></button>
      </li>
      <li class="page-item" *ngFor="let page of getPages(); let i = index" [class.active]="currentPage === page">
        <button class="page-link" (click)="goToPage(+page)">{{ page }}</button>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="nextPage()"><span aria-hidden="true">&raquo;</span></button>
      </li>
    </ul>
  </nav>


</div>